import { render, staticRenderFns } from "./AnketsRegister.vue?vue&type=template&id=9a3d5370&scoped=true"
import script from "./AnketsRegister.vue?vue&type=script&lang=js"
export * from "./AnketsRegister.vue?vue&type=script&lang=js"
import style0 from "./AnketsRegister.vue?vue&type=style&index=0&id=9a3d5370&prod&lang=scss"
import style1 from "./AnketsRegister.vue?vue&type=style&index=1&id=9a3d5370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3d5370",
  null
  
)

export default component.exports